<template>
  <div class="main">
    <div id="top" ref="top"></div>
    <div class="careful-search">
      <span v-for="(item,index) in carefulList" :key="index" :class="activeTab==index?'active-class':''" @click="clickTab(item,index)">{{item.searchValue}}</span>
    </div>
    <searchhead-checkbox ref="searchhead" :placeholderStr="placeholder" @resetUnlockQ="resetUnlockQ" @clear-condition="clearCondition" @set-condition="setCondition"
      @choseActiveTab="handleChoseActiveTab"></searchhead-checkbox>
    <div v-loading.lock="waiting" element-loading-text="请耐心等待，小T为您大数据计算中...">
      <companyReport />
      <company-card-list @isUnlock-Change="isUnlockChange" :resetUnlockS="isUnlock" :companyType="1" class="list-box" :searchType="activeTab" :batchActions="batchActions" ref="cardlist" :list="list"
        @handle-page-num="handlePageNum" @handle-page="handlePage">
        <div class="searchBar">
          <!-- <span class="font-12">关键词：</span>
          <el-tag :title="$route.query.word">{{$route.query.word}}</el-tag> -->
          <span class="font-15-md">小T为您找到 <span class="blueColor" style="color: #5088FF;">{{_totalElements}}</span> 家企业资源</span>
        </div>

        <!-- <el-select class="filtrate-time" style="right: 300px;" v-model="sortType" @change="searchByCondition()">
          <el-option v-for="item in optionsTime" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select> -->
        <template v-slot:beforeBatch>
          <el-button class="gbBatchBtn" :loading="actionLoading" type="info" plain size="small" v-interestExpire @click="batchUnlockFnbefore">解锁前500</el-button>
        </template>
        <template v-slot:two>
          <intel-sort @sortChange="sortChange" :value="sortValue"></intel-sort>
        </template>

      </company-card-list>
    </div>
    <robot />
    <!-- 右侧悬浮箭头 -->
    <right-float ref="rightFloat" :globalRfType="false" @scrollToView="scrollToView"></right-float>
    <div id="bottom" ref="bottom"></div>

    <unlock-dialog-batch :show.sync="unlockDialogShowBatch" :maxTotal="list.total" :list="companyList" title="批量解锁" :confirmPromise="contactsNumBatchConfirmBatch"></unlock-Dialog-Batch>
    <!-- 批量解锁提示 -->
    <batch-unlock-tip ref="batchUnlockTip"></batch-unlock-tip>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import SearchheadCheckbox from '../components/searchHeadCheckBox'
import CompanyCardList from '../components/companyCardList'
import Robot from '../components/robot'
import companyReport from '../components/companyReport'
import intelSort from '@/views/wigects/intelSort'
import { searchByCondition, searchByConditionUnlock } from '../api/index'
import unlockDialogBatch from '../components/unlockDialogBatch'
import batchUnlockTip from '@/components/batchUnlockTip'
import RightFloat from '@/components/rightFloatBtn'
import { X_BLOCK, X_PRODUCT, X_HIDE } from '@/utils/iframeUtils'
import { testPoint } from '../api/newClueApi'
import axios from 'axios'

export default {
  name: 'clueList',
  provide() {
    return {
      unlockSourceType: 1
    }
  },
  components: {
    SearchheadCheckbox,
    CompanyCardList,
    Robot,
    companyReport,
    intelSort,
    unlockDialogBatch,
    batchUnlockTip,
    RightFloat
  },
  data() {
    return {
      // optionsTime: [
      // { value: null, label: '智能排序' },
      // { value: 'amount-1', label: '发布时间从早到晚' },
      // { value: 'amount-2', label: '发布时间从晚到早' },
      // { value: 'establishTime-1', label: '注册资产从高到低' },
      // { value: 'establishTime-2', label: '注册资产从低到高' }
      // ],
      sortType: { sortType: null, sortField: null },
      sortValue: null,
      waiting: false,
      allTotal: 0,
      list: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        tab: 1,
        tableData: []
      },
      condition: {}, // 记录筛选条件
      carefulList: [
        { searchValue: '智能搜索', field: 'word' },
        { searchValue: '企业名称', field: 'companyName' },
        { searchValue: '经营范围', field: 'businessScope' },
        { searchValue: '产品', field: 'productName' },
        { searchValue: '法人/高管', field: 'executives' },
        { searchValue: '专利', field: 'patentName' },
        { searchValue: '地址', field: 'regAddress' },
        { searchValue: '网络推广', field: 'bidKeyWord' }
      ],
      activeTab: 0,
      placeholderList: ['请输入企业名称、手机号、产品名、经营范围、统一信用代码等，多关键词用空格隔开，如：“上海 珍岛”', '请输入企业名称', '请输入主营业务或经营范围关键词', '请输入产品', '请输入一个完整姓名（支持企业法人/高管等）', '请输入专利名称或说明', '请输入地址或地区，系统为您推荐附近企业', '请输入关键词'],
      scrollTop: 0,
      unlockDialogShowBatch: false,
      companyList: [],
      actionLoading: false,
      isUnlock: false,
      windowProductObj: { 'scrmqw': 'SCRM企微', 'scrmzy': 'SCRM专业' },
      sortConditionEnName: [
        { title: '省份地区', value: 'province' }, { title: '城市', value: 'city' },
        { title: '行业分类', value: 'bigIndustry' }, { title: '二级行业', value: 'smallIndustry' },
        { title: '成立时间', value: 'estiblishTime' }, { title: '注册资本', value: 'regCapital' },
        { title: '号码来源', value: 'sourceValues' }, { title: '公司实力', value: 'tags' },
        { title: '经营状态', value: 'regStatus' }, { title: '人员规模', value: 'staffSize' },
        { title: '企业类型', value: 'companyType' }, { title: '网址信息', value: 'website' },
        { title: '资本类型', value: 'capitalType' }, { title: '网络推广', value: 'hasPlatform' },
        { title: '有无手机', value: 'hasPhone' }, { title: '有无关键人', value: 'hasKeyContact' },
        { title: '有无ICP备案', value: 'hasIcp' }, { title: '有无建站', value: 'hasSiteBuilder' },
        { title: '有无抖音店铺', value: 'hasDouyinShop' }, { title: '有无商标', value: 'hasTrademark' },
        { title: '有无专利', value: 'hasPatents' }, { title: '有无软件著作权', value: 'isMsName' },
        { title: '有无抖音号', value: 'hasDy' }
      ],
      searchFlag: false
    }
  },
  beforeDestroy() {
    this.getPageWrapPadding()
  },
  mounted() {
    const { activeTab, city, industry, text, text1 } = this.$route.query
    if (activeTab) {
      this.activeTab = activeTab
    }

    if (city) {
      const cities = []
      cities.push({ label: text })
      text1 && cities.push({ label: text1 })
      this.$refs.searchhead.chooseCity(cities)
      this.$refs.searchhead.expand = true
    }

    if (industry) {
      const industries = []
      industries.push({ label: text })
      text1 && industries.push({ label: text1 })
      this.$refs.searchhead.chooseIndustry(industries)
      this.$refs.searchhead.expand = true
    }
  },
  computed: {
    filterValue() {
      return this.carefulList[this.activeTab].field
    },
    ...mapState({
      surplus: state => state.user.surplus,
      staffInfo: state => state.user.staffInfo
    }),
    batchActions() {
      return this.surplus < 1 ? [false, true, false] : [true, true, false]
    },
    placeholder() {
      return this.placeholderList[this.activeTab]
    },
    _totalElements() {
      if (this.allTotal < 100) return this.allTotal
      if (this.allTotal < 200000) return `${this.allTotal.toString().split('').reduce((res, v) => res ? res + 0 : v, '')}+`
      return '200000+'
    },
  },
  methods: {
    resetUnlockQ(val) {
      this.isUnlock = val
    },
    clearCondition() {
      this.activeTab = 0
    },
    scrollToView(val) {
      document.getElementById(val).scrollIntoView({
        block: 'start',
        inline: 'nearest',
        behavior: 'smooth'
      })
    },
    // 过滤解锁
    isUnlockChange(val) {
      this.isUnlock = val
      this.searchByCondition()
    },
    sortChange(v) {
      this.list.pageNum = 1
      this.sortType = v
      this.sortValue = v.sortType ? `${v.sortField}-${v.sortType}` : null
      this.searchByCondition()
    },
    clickTab(item, index) {
      this.activeTab = index
      // this.$router.replace({ query: { word: this.$refs.searchhead.word } })
    },
    handleChoseActiveTab({ val, important }) {
      if (important) {
        this.activeTab = val
        return
      }
      if (this.activeTab != 1) {
        this.activeTab = 0
      }
    },
    // 搜索无参数、筛选有参数
    setCondition(val) {
      this.searchFlag = true
      this.list.pageNum = 1
      if (val && JSON.stringify(val) !== '{}') {
        this.condition = val
        this.searchByCondition()
      } else {
        this.condition = {}
        this.searchByCondition()
      }
    },
    async searchByCondition() {
      this.$store.dispatch('cancelRequest')
      this.waiting = true
      this.clearAllData()
      let isUnlockN = this.isUnlock ? 1 : 0
      const data = {
        [this.$route.query.field || this.filterValue]: this.$route.query.word && this.$route.query.word.trim(),
        pageNum: this.list.pageNum,
        pageSize: this.list.pageSize,
        ...(this.sortType || {}),
        isUnLock: parseInt(isUnlockN),
        ...this.condition
      }
      const self = this
      try {
        const res = await searchByCondition(data, new axios.CancelToken(function (c) {
          self.$store.commit('SET_REQUIRE', c)
        }))
        if (res.data) {
          const { total = 0, items = [] } = res.data
          this.allTotal = total
          this.list.total = total > 15000 ? 15000 : total
          this.list.tableData = items
          // 埋点
          let companyNameList = []
          let nameList = []
          let unlabeledCompanyName = []
          if (items) {
            items.forEach(v => {
              companyNameList.push(this.removeHtml(v.companyName))
              nameList.push(this.removeHtml(v.name))
              unlabeledCompanyName.push(this.removeHtml(v.unlabeledCompanyName))
            })
          }
          let productName = ''
          if (window[X_PRODUCT]) {
            productName = windowProductObj[window[X_PRODUCT]]
          } else {
            if (window[X_BLOCK]) {
              productName = 'SCRM企微'
            } else {
              if (window[X_HIDE]) {
                productName = 'SCRM专业'
              } else {
                productName = (process.env.NODE_ENV == 'erp-prod' || process.env.NODE_ENV == 'erp') ? 'ERP-臻寻客' : 'T云-臻寻客'
              }
            }
          }
          let paramsM = {
            eventType: 'enterprise_search',
            productName: productName,
            dimension: parseInt(parseInt(this.activeTab) + 1),
            searchFilter: this.sortConditionClassifyName(this.condition),
            keyword: this.$route.query.word && this.$route.query.word.trim(),
            count: this.allTotal,
            searchList: nameList || unlabeledCompanyName || companyNameList,
          }
          if (this.searchFlag) {
            testPoint(paramsM).then(res => {
              this.searchFlag = false
            }).catch(err => {

            })
          }
        }
      } catch (error) {
        console.log('[searchByCondition:err]', error)
      } finally {
        this.waiting = false
      }
    },
    removeHtml(str) {
      if (!str) return
      str = str.replace('<<', '@@@').replace('>>>', '>@1@1@1')
      const reTag = /<(?:.|\s)*?>/g
      return str.replace(reTag, '').replace(/&nbsp;/ig, '').replace('@@@', '<<').replace('@1@1@1', '>>')
    },
    // 筛选条件分类中文名
    sortConditionClassifyName(obj) {
      let arrKeys = Object.keys(obj)
      let arrName = []
      this.sortConditionEnName.forEach(v => {
        arrKeys.forEach(vv => {
          if (v.value == vv) {
            arrName.push(v.title)
          }
        })
      });
      return arrName
    },
    handlePage(val) {
      if (this.list.pageNum !== val) {
        this.list.pageNum = val
        this.searchByCondition()
      }
    },
    handlePageNum(val) {
      this.list.pageNum = 1
      this.list.pageSize = val
      this.searchByCondition()
    },
    clearAllData() {
      this.allTotal = 0
      this.list.total = 0
      this.list.tableData = []
    },
    removeHtml(str) {
      if (!str) return
      const reTag = /<(?:.|\s)*?>/g
      return str.replace(reTag, '').replace(/&nbsp;/ig, '')
    },
    // 批量解锁前500
    batchUnlockFnbefore() {
      // 重新获取解锁数据
      this.$store.commit('SET_FREQUENCY', this.$store.state.user.frequency + 1)
      this.unlockDialogShowBatch = true
      // this.contactsNumBatchV2(this.list.tableData.filter(e => (!e.unlock)).map(e => {
      //     const obj = { companyName: this.removeHtml(e.companyName) ,hid:e.hid}
      //     if (e.similarValue) obj.similarValue = e.similarValue
      //     if (e.similarity) obj.similarity = e.similarity
      //     return obj
      //   }))
    },
    contactsNumBatchV2(companyList) {
      if (companyList.length) {
        // 重新获取解锁数据
        this.$store.commit('SET_FREQUENCY', this.$store.state.user.frequency + 1)
        this.unlockDialogShowBatch = true
        this.companyList = companyList
      } else {
        this.$message.warning('已经解锁过了')
      }
    },
    async contactsNumBatchConfirmBatch() {
      // this.clearAllData()
      let isUnlockN = this.isUnlock ? 1 : 0
      const data = {
        [this.$route.query.field || this.filterValue]: this.$route.query.word && this.$route.query.word.trim(),
        pageNum: this.list.pageNum,
        pageSize: this.list.pageSize,
        source: 1,
        ...(this.sortType || {}),
        ...this.condition,
        isUnLock: parseInt(isUnlockN),

      }
      try {
        const res = await searchByConditionUnlock(data)
        if (res.code == 200) {
          if (this.staffInfo.demonstrationTag != 1) {
            this.$message.warning('批量解锁中，所需时长5分钟，请稍后在解锁列表中查看')
          }
          this.searchByCondition()
          this.$refs.batchUnlockTip.tipTitleF('2')
          this.$refs.batchUnlockTip.getUnlockBatchTip()
        }
      } catch (error) { } finally {
      }

    }
  }
}
</script>
<style lang="scss" scoped>
.font-15-md {
  font-size: 15px;
  font-weight: 600;
  color: rgba(52, 57, 81, 0.7);
}
.filtrate-time {
  position: absolute;
  top: 0px;
  right: 0px;
  display: flex;
  align-items: center;
  height: 100%;
  // /deep/ .el-input__inner {
  //   border: none;
  //   background: none;
  //   box-shadow: none;
  //   color: rgb(79, 122, 253);
  //   font-size: 12px;
  // }

  // /deep/ .el-input__suffix {
  //   i {
  //     display: none;
  //   }
  // }

  // /deep/ .el-input{
  //   &::after{
  //     content: ' ';
  //     display: block;
  //     width: 20px;
  //     height: 20px;
  //   }
  // }
}
.ccl {
  border: 15px solid #f0f2f5;
  border-top: 0;
  margin-top: 0;
  /deep/ .recommend {
    margin: 0;
  }
}
.main {
  position: relative;
}
.main .searchBar {
  position: relative;
  // height: 60px;
  /deep/ .el-tag {
    background-color: #ecf5ff;
    display: inline-block;
    height: 24px;
    padding: 0 12px;
    line-height: 24px;
    font-size: 12px;
    color: #409eff;
    border: none;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;

    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
  }
}
.careful-search {
  position: absolute;
  top: 32px;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 999;
  display: flex;
  justify-content: space-between;
  width: 70%;
  max-width: 910px;
  // width: 770px;
  margin-bottom: 10px;
  .active-class {
    background: #fff;
    color: #2d6ee4;
    position: relative;
    border-radius: 4px;
    font-weight: bold;
  }
  .active-class::after {
    content: "";
    content: "";
    width: 0;
    height: 0;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    bottom: -7px;
    border-top: solid 7px #fff;
    border-right: solid 7px transparent;
    border-left: solid 7px transparent;
  }
  span {
    color: #fff;
    cursor: pointer;
    font-size: 14px;
    padding: 3px 5px;
  }
}
/deep/ {
  .report-box {
    margin-bottom: 10px;
  }
}
.list-box {
  padding-bottom: 0;
  margin-bottom: 24px;
}
.goUPDown {
  position: fixed;
  right: 0px;
  bottom: 70px;
  img {
    cursor: pointer;
    display: block;
    margin: auto;
  }
}
.gbBatchBtn {
  &.el-button {
    color: #333333;
    background: rgba(255, 255, 255, 0.2);
    box-shadow: 0px 2px 4px 0px #edeef3;
    border-radius: 4px;
    border: 1px solid #bbbeca;
    margin-left: 8px;
  }
}
.goMessage {
  .msBox {
    width: 52px;
    height: 52px;
    position: relative;
    .insideMsBox {
      width: 32px;
      height: 32px;
      background: #333333;
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.11);
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      position: absolute;
      border-radius: 50%;
      .message-icon {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
      }
    }
  }
}
</style>
